import {ProductionOrderStatus} from "../model/production-order/ProductionOrder";


export const productionOrderStatusToString = new Map<ProductionOrderStatus, string>([
    [ProductionOrderStatus.WAITING_SELECTION_TECHNOLOGICAL_PROCESS_CHART, 'Выбор технологических карт'],
    [ProductionOrderStatus.IN_LINE, 'В производственной очереди'],
    [ProductionOrderStatus.IN_PRODUCTION, 'В производстве'],
    [ProductionOrderStatus.COMPLETED, 'Завершён']
])
